export const SETTING_WORKER_COLUMN = 'SETTING_WORKER_COLUMN';
export const SETTING_WORKER_INDEX = 'SETTING_WORKER_INDEX';
export const SETTING_WORKER_LOADING_INDEX = 'SETTING_WORKER_LOADING_INDEX';
export const SETTING_WORKER_LOADING_SHOW = 'SETTING_WORKER_LOADING_SHOW';
export const SETTING_WORKER_LOADING_RESOURCE = 'SETTING_WORKER_LOADING_RESOURCE';
export const SETTING_WORKER_OPTION = 'SETTING_WORKER_OPTION';
export const SETTING_WORKER_RESET = 'SETTING_WORKER_RESET';
export const SETTING_WORKER_SEARCH = 'SETTING_WORKER_SEARCH';
export const SETTING_WORKER_SHOW = 'SETTING_WORKER_SHOW';
